/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Documents_Col_UpdatedInputs */

const cs_documents_col_updated = /** @type {(inputs: Documents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Změněno`)
};

const en_documents_col_updated = /** @type {(inputs: Documents_Col_UpdatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changed`)
};

/**
* | output |
* | --- |
* | "Changed" |
*
* @param {Documents_Col_UpdatedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const documents_col_updated = /** @type {((inputs?: Documents_Col_UpdatedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Documents_Col_UpdatedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_documents_col_updated(inputs)
	return cs_documents_col_updated(inputs)
});